import ProductCardList from "./ProductCardListOverride"

import "./ProductCardListOverride.scss"

export default ProductCardList
